import { connect, MapDispatchToProps } from "react-redux";
import RolesComponent, { RoleProps } from "pages/Roles";
import {
  addRoleRequest,
  deleteRoleRequest,
  editRoleRequest,
  moduleListRequest,
  roleListRequest,
  rolePermissionsRequest,
} from "store/role/actions";
import { IRoleContainerDispatch, IRole } from "utils/interfaces/role";

const mapDispatchToProps: MapDispatchToProps<IRoleContainerDispatch, IRole> = {
  roleListRequest,
  addRoleRequest,
  editRoleRequest,
  deleteRoleRequest,
  rolePermissionsRequest,
  moduleListRequest,
};

const connector = connect(null, mapDispatchToProps);

const Roles: React.FC<RoleProps> = (props) => {
  return <RolesComponent {...props} />;
};

export default connector(Roles);
